import React from 'react';
import _ from 'lodash';
import plotly from 'plotly.js';
import plotComponentFactory from 'react-plotly.js/factory';
import { evaluate, compile } from 'mathjs';

const Plot = plotComponentFactory(plotly);


class PlotBiseccion extends React.Component {


    render() {

        if (this.props.datos.solution.length > 0) {

            const estado = this.props.datos.form.values;

            if (_.toNumber(estado.error) >= 1) {
                return (
                    <div className="eleven wide column">
                        <h2>Error</h2>
                        <p>Error mayor que 1.</p>
                    </div>
                )
            } else if (evaluate(_.toLower(estado.funcion), { x: _.toNumber(estado.rango_a) }) * evaluate(_.toLower(estado.funcion), { x: _.toNumber(estado.rango_b) }) > 0) {
                const x_array = _.range(_.toNumber(estado.rango_a), _.toNumber(estado.rango_b), 0.5);
                const y_func = compile(_.toLower(estado.funcion));

                const y_array = [];

                for (var i = 0; i < x_array.length; i++) {
                    y_array.push(y_func.evaluate({ x: x_array[i] }))
                };
                return (
                    <div className="eleven wide column">
                        <h2>Error</h2>
                        <p>No hay raiz en el rango.</p>
                        <Plot
                            data={[
                                { type: 'lines', x: x_array, y: y_array, name: 'f(x)' }
                            ]}
                            layout={{ autosize: true, staticPlot: true, xaxis: { title: 'x' }, yaxis: { title: 'f(x)' } }}
                        />
                    </div>
                )
            }

            const x_array = _.range(_.toNumber(estado.rango_a), _.toNumber(estado.rango_b), 0.5);
            const y_func = compile(_.toLower(estado.funcion));

            const y_array = [];

            for (var j = 0; j < x_array.length; j++) {
                y_array.push(y_func.evaluate({ x: x_array[j] }))
            };

            const resultados_y = [];

            for (var k = 0; k < this.props.datos.solution.length; k++) {
                resultados_y.push(y_func.evaluate({ x: this.props.datos.solution[k] }))
            };

            return (
                <Plot
                    data={[
                        { type: 'lines', x: x_array, y: y_array, name: 'f(x)' },
                        { type: 'scatter', mode: 'markers', x: this.props.datos.solution, y: resultados_y, name: 'soluciones', }
                    ]}
                    layout={{ autosize: true, staticPlot: true, xaxis: { title: 'x' }, yaxis: { title: 'f(x)' } }}
                />

            )
        }
        else {
            return (<div></div>)
        }

    }
}

export default PlotBiseccion;